import { FC, useState } from "react";
import { Blurhash } from "react-blurhash";

interface BlurHashAvatarProps {
  src?: string;
  blurHash?: string;
  alt: string;
  className?: string;
  containerClassName?: string;
  roundedClassName?: string;
  borderClassName?: string;
}

const BlurHashAvatar: FC<BlurHashAvatarProps> = ({
  src,
  blurHash,
  alt,
  className = "",
  containerClassName = "",
  roundedClassName = "rounded-full",
  borderClassName = "",
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className={`relative aspect-square ${containerClassName} ${roundedClassName} overflow-hidden`}>
      {blurHash && (
        <div className={`absolute inset-0 ${roundedClassName} ${borderClassName} overflow-hidden`}>
          <Blurhash
            hash={blurHash}
            width="100%"
            height="100%"
            resolutionX={32}
            resolutionY={32}
            punch={1}
            className={`w-full h-full ${
              imageLoaded ? "animate-fade-out" : ""
            }`}
          />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`relative w-full h-full object-cover ${roundedClassName} ${borderClassName} ${className} ${
          imageLoaded ? "animate-fade-in" : "opacity-0"
        }`}
        onLoad={() => setTimeout(() => setImageLoaded(true), 100)}
      />
    </div>
  );
};

export default BlurHashAvatar; 